import {
  getEventDateRange,
  getTodayDateOnly,
} from './eventDateRange';

/**
 * Classifies an event by its date as 'live' (ongoing today),
 * 'finished' (past) or 'upcoming' (future). Returns null when
 * the event has no usable date.
 *
 * Both fixed and segmented events are reduced to a single [start, end] range
 * via getEventDateRange so the badge and the date label stay in sync.
 */
const getEventStatus = (rawDate, today = getTodayDateOnly()) => {
  const range = getEventDateRange(rawDate);
  if (!range) return null;

  if (today > range.endDate) return 'finished';
  if (today < range.startDate) return 'upcoming';
  return 'live';
};

/**
 * A cancellation lives on the event record, not on its dates: a cancelled
 * event keeps its (possibly future) dates but is no longer live, bookable or
 * advertised. Callers check this before the date-derived status so
 * "Cancelled" wins over Live / Past / In Xd.
 */
export const isEventCancelled = (event) =>
  String(event?.status || '').toLowerCase() === 'cancelled';

export default getEventStatus;
